import { CheckboxFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/CheckboxFilter";
import { CheckboxFilterResult } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/CheckboxFilterResult";
import { CheckboxFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/CheckboxFilterModel";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import { appsFilterCategoryMap } from "../../types/filterCategory";

const createBusinessModelFilter = (businessModels: readonly string[]): SearchFilterInstance => ({
    key: "appBusinessModels",
    trackingName: "App Business Model",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.business-models.title" },
    tooltipText: { key: "si.find_apps.filters.business-models.tooltip" },
    filter: new CheckboxFilterModel(businessModels, "si.find_apps.filters.business-models.option"),
    filterView: CheckboxFilter,
    filterResultView: CheckboxFilterResult,
});

export default createBusinessModelFilter;
